export enum ApiVersion
{
    V1 = 'v1'
}

export interface AuthSettings
{
    baseUrl?: string;
    loginUrl?: string;
    logoutUrl?: string;
    refreshUrl?: string;
}

export interface ApiSettings
{
    baseUrl: string;
    version?: ApiVersion;
}

export interface MapSettings
{
    apiKey: string;
}

export interface TurnstileSettings
{
    siteKey: string;
    cloudflareBaseUrl: string;
}

export class AuthSettingsUtils
{
    static getLoginUrl(settings: AuthSettings): string {
        return `${settings.baseUrl}/${settings.loginUrl}`;
    }

    static getLogoutUrl(settings: AuthSettings): string {
        return `${settings.baseUrl}/${settings.logoutUrl}`;
    }

    static getRefreshUrl(settings: AuthSettings): string {
        return `${settings.baseUrl}/${settings.refreshUrl}`;
    }
}

export class ApiSettingsUtils
{
    static getApiUrl(settings: ApiSettings, path: string): string {
        if (settings.version) return `${settings.baseUrl}/${settings.version}/${path}`;
        else return `${settings.baseUrl}/${path}`;
    }
    
    static getBaseApiUrl(settings: ApiSettings): string {
        if (settings.version) return `${settings.baseUrl}/${settings.version}`;
        else return `${settings.baseUrl}`;
    }
}

export interface Configuration
{
    authSettings: AuthSettings;
    apiSettings: ApiSettings;
    turnstileSettings: TurnstileSettings;
    production: boolean;
}
